<template>
    <div id="editor_novel">
        <div class="editor_novel">作品信息</div>
        <div class="editor_novel1">
            <div class="editor_novel2">
                <div class="editor_novel3">
                    <div class="editor_novel4">小说名称:</div>
                    <div class="editor_novel5">{{ novelInfo.title }}</div>
                </div>
                <div class="editor_novel3">
                    <div class="editor_novel4">小说作者:</div>
                    <div class="editor_novel5">{{ novelInfo.author }}</div>
                </div>
                <div class="editor_novel3">
                    <div class="editor_novel4">核心受众:</div>
                    <div class="editor_novel5">{{ novelInfo.target>0 ?'女频':'男频' }}</div>
                </div>
                <div class="editor_novel3">
                    <div class="editor_novel4">小说类型:</div>
                    <div class="editor_novel5">{{ novelInfo.categorys }}</div>
                </div>
                <div class="editor_novel3">
                    <div class="editor_novel4">小说状态:</div>
                    <div class="editor_novel5">{{ novelInfo.status == 0 ? '连载中' : "已完结" }}</div>
                </div>
                <div class="editor_novel3">
                    <div class="editor_novel4">小说章节:</div>
                    <div class="editor_novel5">{{ novelInfo.chapters }}</div>
                </div>
                <div class="editor_novel3">
                    <div class="editor_novel4">小说字数:</div>
                    <div class="editor_novel5">{{  $validata.formatNumberToUnit(novelInfo.words, 1)  }}</div>
                </div>
                <div class="editor_novel3">
                    <div class="editor_novel4">阅读人数:</div>
                    <div class="editor_novel5">{{ $validata.formatNumberToUnit(novelInfo.reads, 1) }}</div>
                </div>
            </div>
            <div class="editor_novel6">
                <div class="editor_novel7">书籍简介:</div>
                <div class="editor_novel8">{{ novelInfo.introduction }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import HApi from '@/api/hottc'
export default {
    data() {
        return {
            novelInfo: {},
            sex: '',
            labels: '',
            protagonist: ''
        }
    },
    created() {
        let { uid } = this.$route.query
        if (uid) {
            HApi.novelDetail(uid).then(res => {
                if (res.code === 200) {
                    this.novelInfo = res.data || {}
                } else {
                    this.$message.warning(res.msg)
                }
            })
        }
    },
   
}
</script>

<style lang="scss" scoped>

#editor_novel {
    height: 100%;
}

.editor_novel {
    width: 100%;
    height: 67px;
    font-size: 19px;
    color: #666666;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #E6EBF0;
}

.editor_novel1 {
    width: 100%;
    height: calc(100% - 68px);
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.editor_novel2 {
    padding: 20px 15px 10px;
    border-bottom: 1px solid #E6EBF0;
}

.editor_novel3 {
    display: flex;
    margin-bottom: 10px;
}

.editor_novel4 {
    width: 80px;
    font-size: 17px;
    color: #666666;
}

.editor_novel5 {
    flex: 1;
    font-size: 17px;
    color: #111111;
}

.editor_novel6 {
    padding: 20px 15px 0;
    margin-bottom: 20px;
}

.editor_novel7 {
    font-weight: bold;
    font-size: 17px;
    color: #333333;
    margin-bottom: 10px;
}

.editor_novel8 {
    background: #F8F9FA;
    box-shadow: 0px 0 8px 0px rgba(117, 53, 0, 0.06);
    border-radius: 8px;
    font-size: 17px;
    color: #666666;
    padding: 13px;
}
</style>